// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3hMct","location":"Header_location__1Oouw"};